import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Fragment, memo, useCallback, useMemo, useRef, useState } from 'react';
import { publish } from "../../lib/EventBuser";
import { VALUELIST_REFRESH } from "../../lib/events";
import ValueListList from "./ValueListList";
import FormValueList from "./FormValueList/index";
const ValueLists = _ref => {
  let {
    timeZone,
    onUpdate,
    overrides
  } = _ref;
  const form = useRef();
  const [activeRowId, setActiveRowId] = useState(null);
  const tracking = overrides === null || overrides === void 0 ? void 0 : overrides.tracking;
  const onCreate = useCallback(() => {
    form.current.open({});
    onUpdate && onUpdate();
    (tracking === null || tracking === void 0 ? void 0 : tracking.create) && tracking.create();
  }, [onUpdate, tracking]);
  const onEdit = useCallback(row => {
    if (row.isView) return;
    setActiveRowId(row.id);
    form.current.open({
      id: row.id,
      isEditable: row.canEdit
    });
    (tracking === null || tracking === void 0 ? void 0 : tracking.update) && tracking.update();
  }, [tracking]);
  const onDuplicate = useCallback(row => {
    form.current.open({
      id: row.id,
      isForDuplicate: true,
      isEditable: row.canEdit
    });
    onUpdate && onUpdate();
  }, [onUpdate]);
  const refreshList = useCallback(() => publish(VALUELIST_REFRESH), []);
  const finalOverrides = useMemo(() => _objectSpread(_objectSpread({}, overrides), {}, {
    columnsToHide: (overrides === null || overrides === void 0 ? void 0 : overrides.valueListColumnsToHide) || []
  }), [overrides]);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ValueListList, {
    activeRowId: activeRowId,
    setActiveRowId: setActiveRowId,
    onCreate: onCreate,
    onEdit: onEdit,
    onDuplicate: onDuplicate,
    overrides: overrides
  }), /*#__PURE__*/React.createElement(FormValueList, {
    setActiveRowId: setActiveRowId,
    onRef: ref => form.current = ref,
    refreshList: refreshList,
    timeZone: timeZone,
    overrides: finalOverrides,
    onUpdate: onUpdate
  }));
};
process.env.NODE_ENV !== "production" ? ValueLists.propTypes = {} : void 0;
export default /*#__PURE__*/memo(ValueLists);